import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

type ConfirmationDialogProps = {
  open: boolean;
  onClose: (confirm: boolean) => void;
};

const ConfirmationDialog = ({ open, onClose }: ConfirmationDialogProps) => (
  <Dialog open={open} onClose={() => onClose(false)}>
    <DialogTitle>Confirmation</DialogTitle>
    <DialogContent>
      <DialogContentText>Are you sure you want to be redirected to the User Management page?</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={() => onClose(false)} color="primary">
        Cancel
      </Button>
      <Button onClick={() => onClose(true)} color="primary" autoFocus>
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmationDialog;
